export const environment = {
  production: true,
  apiPath:'https://apiv2.shiprocket.co/v1/',
  partnerServiceabilityHost: 'https://sr-quick-partner-serviceability.shiprocket.in',
  rbBaseUrl: 'https://app-cargo.shiprocket.in/',
  copilot_base_url : 'https://copilot.shiprocket.in/',
  googleAppID: '624796833023-clhjgupm0pu6vgga7k5i5bsfp6qp6egh.apps.googleusercontent.com',
  facebookAppID: '866222157439736',
  fbAuth : {appID : '719834648216007', redirect_uri : '/login/social-auth',  newredirect_uri : '/newlogin/newsocial-auth', backendApi: 'auth/login/facebookv2/callback'},
  googleAuth : {ClientID: '415578535638-taan01jiogdj99gb3g4bdn4friqeuer8.apps.googleusercontent.com', redirect_uri : '/login/social-auth', newredirect_uri : '/newlogin/newsocial-auth', backendApi: 'auth/login/google/callback'},
  OneSignalKey: '18c5be6c-3de4-4272-a06c-b98310b9d3c7',
  mySrRedirectUrl: 'https://my.shiprocket.in/',
  srWaveBaseUrl: 'https://sr-wave-api.shiprocket.in/v1/',
  capitalPanelURL: 'https://capital.shiprocket.in/',
  capitalApiUrl:"https://capital-api.shiprocket.in/",
  jetshopBaseUrl: 'https://app.jetshop.co/',
  POSTHOG_KEY: '',
  POSTHOG_HOST: '',
  MOENGAGE_APP_ID: 'FTA8BPMY1GXFX8QC88JEUSAV',
  MOENGAGE_CLUSTER: 'DC_3',
  BillingGoBaseUrl: "https://srbs-go.shiprocket.in/v1/",
  ShiprocketGoBaseUrl: "https://sr-go.shiprocket.in/api/v1/",
  BillingBaseUrl: "https://srbs.shiprocket.in/api/1.0/",
  VasBillingBaseUrl: "https://sr-wallet.shiprocket.in/api/v1/",
  srAuth: 'https://sr-auth.shiprocket.in/',
  googleMapsApiKey: 'AIzaSyD1fnbvanls59gFqKb14EPuPiPi5I6fhXA',
  srFinanceBaseUrl: 'https://sr-finance.shiprocket.in/api/v1/',
  VasMicroserviceBaseUrl: "https://vas.shiprocket.in/api/v1/",
  recaptchaSiteKey: '6Lf9AuohAAAAANaxTA97hiGnvTMxvXMLXtqDWm7y',
  agenticPlatformUrl: 'https://app.shiprocket.in/platform',
  cubeApm: {
    beacon: 'cubeapm-external.shiprocket.in',
    errorBeacon: 'cubeapm-external.shiprocket.in',
    licenseKey: 'NRJS-123456789abcdef0123',
    applicationID: 'seller%3BUNSET',
    accountID: '1234567',
    trustKey: '1234567',
    agentID: '123456789',
  },
  HELPDESK: 'https://helpdesk-api.shiprocket.in/v1/',
  agentWidgetId: '6a8d4af56e0b09bb95c05848',
};






/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
